import React, { useState, useEffect } from "react";
import { Tooltip, Table } from "antd";
import moment from "moment";

const ErpVirmanMatchedTransaction = (props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [virmanTransactions, SetVirmanTransactions] = useState({
    data: props.Data,
    loading: false,
  });

  const onTableSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys);
  };

  useEffect(() => {
    if (selectedRowKeys.length != 0) {
      const selectedRowsData = virmanTransactions.data.filter((row) =>
        selectedRowKeys.includes(row.id)
      );

      props.SelectedVirmanTransactions(selectedRowsData);
    }
  }, [selectedRowKeys]);

  const Columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Tutar",
      dataIndex: "amountString",
      editable: true,
      render: (data) => <span style={{ whiteSpace: "nowrap" }}>{data}</span>,
    },
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },

    {
      title: "Açıklama",
      dataIndex: "description",
      render: (text, row, index) => (
        <Tooltip placement="topLeft" title={text}>
          <div style={{ whiteSpace: "break-spaces" }}>
            {text?.trim()?.length > 60 ? text.substring(0, 125) + "..." : text}
          </div>
        </Tooltip>
      ),
    },
  ];

  return (
    <div>
      <p
        style={{ fontWeight: "400" }}
        hidden={props.transactionProcessType === 1 ? true : false}
      >
        Erp'ye aktarmak istediğiniz hareketler arasında virman hareketler
        bulunmaktadır. Lütfen Erp'ye aktarmak istediğiniz virman hareketleri
        seçiniz ve Tamam'a tıklayınız.
      </p>
      <p
        style={{ fontWeight: "600" }}
        hidden={props.transactionProcessType === 1 ? true : false}
      >
        Seçili olmayan hareketlerin statüsü Erp'ye aktarılmadan Aktarıldı olarak
        güncellenecektir.
      </p>
      <p
        style={{ fontWeight: "400" }}
        hidden={props.transactionProcessType === 2 ? true : false}
      >
        Erp'ye aktarmak istediğiniz hareketler arasında virman hareketler
        bulunmaktadır. Lütfen virman hareket olarak işaretlemek istediğiniz
        hareketleri seçiniz ve Tamam'a tıklayınız.
      </p>

      <p
        style={{ fontWeight: "600" }}
        hidden={props.transactionProcessType === 2 ? true : false}
      >
        Virman olarak işaretlediğiniz hareketlerin karşı hareketleri "Erp Giden
        İşlemler" menüsünde gösterilmeyecektir.
      </p>
      <br />
      <Table
        rowSelection={{
          selectedRowKeys: selectedRowKeys,
          onChange: onTableSelectChange,
        }}
        columns={Columns}
        dataSource={virmanTransactions.data}
        loading={virmanTransactions.loading}
        pagination={false}
        sortable={true}
        rowKey="id"
        size="small"
        bordered={false}
        showHeader={true}
      ></Table>
    </div>
  );
};

export default ErpVirmanMatchedTransaction;
